import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const ConditionalPublish: LoadableType<{
	contentId: string;
	spaceKey: string;
	setCheckIfConditionPreventingPublish(value: () => Promise<boolean>): void;
}> = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ConditionalPublish" */ './ConditionalPublish.tsx'))
			.ConditionalPublish,
});
